import { getProtected, postProtected } from './utils';

export var getMessages = function getMessages(playerSessionID) {
  return getProtected('/internalmessages', playerSessionID);
};

export var getMessagesWithStatus = function getMessagesWithStatus(playerSessionID, status) {
  return getProtected('/internalmessages/with-status?status=' + status, playerSessionID);
};

export var getMessage = function getMessage(playerSessionID, messageID) {
  return getProtected('/internalmessages/' + messageID, playerSessionID);
};

export var markMessage = function markMessage(playerSessionId, data) {
  return postProtected('/internalmessages/mark', playerSessionId, data);
};

export default {
  getMessages: getMessages,
  getMessagesWithStatus: getMessagesWithStatus,
  getMessage: getMessage,
  markMessage: markMessage
};